export default __webpack_public_path__ + "media/images/attachment-38bbfdac.svg";